var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_10995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4189 36.486V23.8181C57.4189 18.7285 53.6475 14.6025 48.9951 14.6025H24.178",
    stroke: "#5ABB1A",
    strokeWidth: 7.89905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7148,
    y: 15.085,
    width: 28.3395,
    height: 17.5885,
    rx: 8.79423,
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9077 31.4463L57.462 31.3067C63.2206 31.1286 68.0606 35.6161 68.2459 41.3236L68.4942 49.5418C68.6724 55.3004 64.1921 60.0893 58.4263 60.3185L53.8719 60.4581C48.1134 60.6363 43.2734 56.1487 43.088 50.4412L42.8397 42.223C42.6615 36.4644 47.1491 31.6245 52.9077 31.4463Z",
    fill: "#5ABB1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0777 27.0158L47.6462 26.8895C53.5976 26.8561 58.4502 31.6504 58.4847 37.5977L58.6109 59.338C58.6455 65.2853 53.8489 70.1336 47.8975 70.1669L25.329 70.2933C19.3776 70.3266 14.525 65.5324 14.4905 59.585L14.3643 37.8447C14.3297 31.8974 19.1263 27.0492 25.0777 27.0158Z",
    fill: "#A56644"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1073 52.9756C49.4512 52.571 50.2188 51.1766 49.8218 49.8612C49.7215 49.5287 49.4311 49.1283 49.0532 48.7156L48.9526 48.6077C48.9356 48.5897 48.9184 48.5716 48.901 48.5536L48.7953 48.4452C48.7774 48.4272 48.7594 48.4091 48.7413 48.3911L48.6313 48.2828L48.462 48.121L48.3468 48.014L48.2304 47.9077L48.054 47.7505L47.9359 47.6474L47.759 47.4959L47.6419 47.3973L47.4683 47.2536L47.2985 47.1155L47.0804 46.9415L46.9248 46.8194L46.5965 46.5675L46.2992 46.3457L46.0528 46.1672L45.9418 46.4639L45.8212 46.8004L45.75 47.0058L45.6537 47.2915L45.5727 47.5399L45.5107 47.7359L45.4482 47.9388L45.3654 48.218L45.3044 48.4325L45.2647 48.5771L45.207 48.7957L45.1701 48.9421L45.1345 49.0885C45.1287 49.1129 45.123 49.1373 45.1174 49.1616L45.0843 49.3074L45.0532 49.4524C45.0482 49.4765 45.0432 49.5005 45.0384 49.5245L45.0105 49.6675C45.0015 49.7149 44.993 49.7621 44.9849 49.8088L44.9619 49.9481L44.9417 50.0849C44.9386 50.1075 44.9356 50.1299 44.9327 50.1523L44.9169 50.2847C44.8721 50.6991 44.8758 51.0633 44.9552 51.3264C45.3522 52.6418 46.7634 53.3802 48.1073 52.9756Z",
    fill: "#80411F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2802 52.1451C39.4637 51.4196 40.2007 50.9811 40.9257 51.1643C41.6507 51.3476 42.0907 52.0838 41.9071 52.8093L41.8866 52.8906C41.7796 53.3136 41.6306 53.7211 41.4437 54.1078C43.6484 55.3575 46.1228 56.0569 48.6565 56.1459L49.3345 56.1697C50.0818 56.1959 50.6672 56.8226 50.6411 57.5705C50.6149 58.3184 49.9871 58.9026 49.2397 58.8764L48.5617 58.8525C45.5614 58.7472 42.632 57.9116 40.0278 56.4183L39.754 56.2613C39.4445 56.517 39.1093 56.745 38.7519 56.9409L38.677 56.982C38.0212 57.3415 37.1978 57.1018 36.8378 56.4462C36.4775 55.7903 36.7177 54.9669 37.3737 54.6073L37.4486 54.5662C38.3514 54.0713 39.0074 53.2237 39.2596 52.2264L39.2802 52.1451Z",
    fill: "#80411F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.84797,
    height: 8.88642,
    rx: 2.92398,
    transform: "matrix(-0.999997 0.0024866 0.00434507 0.999991 55.2031 38.0947)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.84797,
    height: 8.88642,
    rx: 2.92398,
    transform: "matrix(-0.999997 0.00253591 0.00426058 0.999991 42.3354 38.0801)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0928 22.125V43.5064L18.2104 42.7967V22.125H26.0928Z",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4296 16.9434V39.6541L10.5488 38.9002V25.8241C10.5488 20.9194 14.5249 16.9434 19.4296 16.9434Z",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2661 32.5088L16.8204 32.3692C22.579 32.1911 27.4189 36.6786 27.6043 42.3861L27.8526 50.6043C28.0308 56.3629 23.5505 61.1518 17.7847 61.381L13.2303 61.5206C7.47175 61.6988 2.63178 57.2112 2.44639 51.5037L2.19812 43.2855C2.01995 37.5269 6.50747 32.687 12.2661 32.5088Z",
    fill: "#78C800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6275 38.1283L14.409 38.043C17.926 37.9342 20.8819 40.6749 20.9951 44.1607L21.1467 49.1798C21.2556 52.6968 18.5193 55.6215 14.9979 55.7616L12.2164 55.8468C8.69945 55.9556 5.74351 53.2149 5.63029 49.7291L5.47866 44.71C5.36984 41.193 8.11053 38.2371 11.6275 38.1283Z",
    fill: "#5ABB1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1948 36.486V23.8181C14.1948 18.7285 18.3208 14.6025 23.4104 14.6025H50.5599",
    stroke: "#78C800",
    strokeWidth: 7.89905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.3027,
    y: 21.9355,
    width: 26.3047,
    height: 17.5885,
    rx: 8.79423,
    transform: "rotate(-47.1199 38.3027 21.9355)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5935 4.11698L21.091 17.4993C15.9732 21.4006 17.641 32.956 24.9632 32.6946V30.3359H29.4761C31.6764 30.3359 33.7968 29.5111 35.4187 28.0243L47.4434 17.0013C51.2111 13.5475 51.2302 7.61372 47.4849 4.13574C44.1344 1.02448 38.9538 1.01631 35.5935 4.11698Z",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5957 22.7514C22.5957 18.5174 26.0281 15.085 30.2622 15.085L49.9204 15.085C54.1544 15.085 57.5868 18.5174 57.5868 22.7514C57.5868 26.9855 54.1544 30.4179 49.9204 30.4179H22.5957V22.7514Z",
    fill: "#242323"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_10995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.817871 0.920898)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadphones);
export default __webpack_public_path__ + "static/media/icon-headphones.578d3c535f4314ba29b60a84d57c4a85.svg";
export { ForwardRef as ReactComponent };